module.exports = __webpack_public_path__ + "static/media/online-health-doctor.ccf0c268.svg";